'use strict';

import React from 'react';
import LabelClaro from './LabelClaro';

class InlineInputClaro extends React.Component{

    render(){
        let wrapperClass = 'form-group';
        let spanIconClass= 'input-group-addon error-icon hide'
        if(this.props.error && this.props.error.length > 0){
            wrapperClass += ' has-error';
            spanIconClass = 'input-group-addon error-icon';
        }
        return (
            <div className={ wrapperClass }>
                <LabelClaro htmlFor={this.props.idElement} labelText={this.props.labelText} labelTip={this.props.labelTip} className={this.props.labelClassName} />
                <div className={this.props.inputClassName}>
                    <input
                        id={this.props.idElement}
                        name={this.props.idElement}
                        type={this.props.inputType}
                        className="form-control"
                        placeholder={this.props.placeholderText}
                        value={this.props.value}
                        onChange={this.props.onChange}
                    />
                    <span className={ spanIconClass }>
                       <i className="fa fa-exclamation-triangle"></i>
                    </span>
                    <span className="help-block error-wrapper error-invalid">{this.props.error}</span>
                    {this.props.additionalMessage}
                </div>
            </div>
        );
    }
}

export default InlineInputClaro;